/**
 * 组合图层合并时的小图倍率策略，依据含特效外扩的实际绘制边界判断是否允许双倍出图
 * 仅供 Group Canvas 导出使用，屏幕预览和特效渲染继续使用各自的资源尺寸策略
 */
import type { BoundingBox } from '@/version-types';

/** 组合允许双倍导出的实际绘制尺寸上限（含特效外扩），宽高均须严格小于此值 */
const SMALL_GROUP_SIZE_LIMIT = 1000;

/**
 * 按实际绘制范围判断本次组合导出是否允许跳过画布尺寸与屏幕 DPR 限制
 *
 * @param renderBox - 本次导出的实际绘制范围，包含特效外扩
 * @param scale - 调用方请求的倍率，仅对双倍导出开放小图策略
 * @returns 实际宽高均为有效正数且小于 1000，并请求双倍导出时返回 true
 */
export function canUseSmallGroupDoubleScale(renderBox: Pick<BoundingBox, 'width' | 'height'>, scale: number): boolean {
    return (
        scale === 2 &&
        [renderBox.width, renderBox.height].every(
            (size) => Number.isFinite(size) && size > 0 && size < SMALL_GROUP_SIZE_LIMIT,
        )
    );
}
